export enum CardViewEnum {
  COMPACT = 'compact',
  NORMAL = 'normal',
  EXPANDED = 'expanded',
}

export const NEW_CARD = 'NEW_CARD';
export const UPDATED_CARD = 'UPDATED_CARD';
